module.exports = __webpack_public_path__ + "static/media/secure.d677a7b4.svg";